/** Confirmed customer prices. Bed drawers: $1,500 per bunk set, October 23, 2026. Other selections retain October 3 prices. */
export const BASIC_UPGRADE_PRICES = { bedDrawers: 1500, stairs: 1725, stairDrawers: 1725, towerSoffit: 1725, puckUpper: 575, puckLower: 575 } as const
export type BasicUpgradeKey = keyof typeof BASIC_UPGRADE_PRICES
export type BasicUpgrades = Partial<Record<BasicUpgradeKey, boolean>> & { bedDrawerFlat?:boolean }
export type BasicUpgradeSelection = BasicUpgrades & { bedId: string }
export const BASIC_UPGRADE_LABELS: Record<BasicUpgradeKey, string> = {
 bedDrawers: 'Bed Drawers',
 stairs: 'Staircase with included niches', stairDrawers: 'Stair drawers',
 towerSoffit: 'Ceiling-height tower posts & soffit', puckUpper: 'Upper-bunk puck light', puckLower: 'Lower-bunk puck light',
}
export function basicUpgradeTotal(upgrades: BasicUpgrades = {}) {
 return (Object.keys(BASIC_UPGRADE_PRICES) as (keyof typeof BASIC_UPGRADE_PRICES)[]).reduce((sum,key)=>sum+(upgrades[key]?BASIC_UPGRADE_PRICES[key]:0),0)
}
export function hasBasicUpgrades(upgrades: BasicUpgrades = {}) { return !!upgrades.bedDrawers || basicUpgradeTotal(upgrades)>0 }
export function isBasicUpgradeSelections(value: unknown, beds: {id:string;kind?:string;servesBedIds?:string[]}[]): value is BasicUpgradeSelection[] {
 if(!Array.isArray(value)||value.length>beds.length)return false
 const ids=new Set<string>()
 return value.every(u=>{
  if(!u||typeof u!=='object'||typeof u.bedId!=='string'||ids.has(u.bedId)||!beds.some(b=>b?.id===u.bedId&&!b.kind))return false
  ids.add(u.bedId)
  if(Object.keys(u).some(k=>k!=='bedId'&&(!(k in BASIC_UPGRADE_PRICES)&&k!=='bedDrawers'&&k!=='bedDrawerFlat'||typeof u[k]!=='boolean')))return false
  const assigned=beds.some(b=>b?.kind==='stairs'&&Array.isArray(b.servesBedIds)&&b.servesBedIds.includes(u.bedId))
  return (!u.puckUpper||!!u.towerSoffit)&&(!u.stairs||assigned)&&(!u.stairDrawers||u.stairs&&assigned)
 })
}


/** Upper lights mount to the tower soffit; never retain them without it. */
export function normalizeBasicUpgrades(upgrades: BasicUpgrades = {}): BasicUpgrades {
 return upgrades.puckUpper && !upgrades.towerSoffit ? {...upgrades, puckUpper:false} : upgrades;
}

